document.addEventListener('DOMContentLoaded', function(){
  if($('.accordion').length) {
    $('.accordion > dt').on('click', function(){
      $(this).next('dd').slideToggle(400);
    });
  }

  if($('.lang-container').length){
    $('.lang-select-nav').show();
    $('.lang-select-nav a').on('click', function(e){
      e.preventDefault();
      $('.lang-select-nav a').removeClass('selected');
      $(this).addClass('selected');
      var tgt = '.lang-' + $(this).attr('data-lang');
      $('.lang-container').hide();
      $(tgt).show();
    });
  }
});
